import React from 'react';
export default function CaretDownIcon() {
    return <svg width="24" height="24" viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.19995 7.5L12.2 12.5L18.2 7.5" stroke="#A0A4A8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>;
};